import useBotControlStore from "../../../../storeModules/useBotControlStore";
import trackConversacaoStep from "../../../../utils/trackConversacaoStep";

const META_STEPS = ["verifica_retomada", "retomar_conversa"];

const handleOptionClick = async (option) => {
  const { lastRenderedStep } = useBotControlStore.getState();

  // Não rastreia meta-steps de navegação (não são parte da conversa real)
  if (!META_STEPS.includes(lastRenderedStep.name || "")) {
    await trackConversacaoStep({
      stepName: lastRenderedStep.name || "",
      userMessage: option.text,
      userOnly: true,
    });
  }

  const controlStoreState = useBotControlStore.getState();

  const time = new Date().toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  const userMessage = {
    sender: "user",
    text: option.text,
    time: time,
  };

  useBotControlStore.setState({
    ...controlStoreState,
    messages: [...controlStoreState.messages, userMessage],
  });

  if (option.nextStep !== undefined) {
    setTimeout(() => {
      const controlStoreState = useBotControlStore.getState();

      useBotControlStore.setState({
        ...controlStoreState,
        currentStep: option.nextStep,
      });
    }, 0);
  }

  if (option.setSelectedPlan) {
    option.setSelectedPlan();
  }
};

export default handleOptionClick;
